

const atualizarEndereco = ({ commit }, endereco) => {
    commit('atualizarEndereco', endereco);
}

export default {
    atualizarEndereco
}